import { hasFeatureFlag } from '../FeatureUtil';
import { hasModule } from '../ModuleUtil';
import { MODULE_TYPES } from '../../../../constants';
export function isSageAccount() {
    return hasFeatureFlag('use_sage_service_for_time_regs') && hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED);
}
